import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	View
} from "react-native";

import InputContainer from "./Layout/InputContainer";
import StyledButton from "ae-base/Base/StyledButton";
import StyledIconButton from "ae-base/Base/StyledIconButton";

import Breakpoints from "react-native-dimensions-breakpoints";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import Style from "ae-style";

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		container: {
			flexDirection: "row",
			justifyContent: "flex-end"
		},
		spacer: {
			margin: Style.layout.marginSlim
		},
		buttons: {
			alignItems: "center"
		}
	},
	512: {
		buttons: {
			width: 150
		}
	}
});

export default class IncrementalButtons extends Component {
	constructor(props){
		super(props);
		var schema = props.schema || {};
		var max = schema.max || props.max;

		this.state = {
			number: 0
		};
		this.max = max;
		this.onPrevious = onPrevious.bind(this);
		this.onNext = onNext.bind(this);
		this.onChangePage = props.onChangePage ? props.onChangePage : (() => {});
	}

	jumpTo(number){
		if(number > this.max)
			number = this.max;
		this.setState({
			number: number
		});
		this.props.onChange(number);
	}

	render(){
		var context = this.context;
		var localize = context.localize;
		var max = this.max;
		var number = this.state.number;
		var changed = this.props.changed;

		var previousDisabled = number === 0;
		var nextDisabled =  number === max || !changed;
		var isMobile = Breakpoints.smallerThan("mobile");

		var nextText = localize("incrementalform.next");
		var previousText = localize("incrementalform.previous");

		var renderPreviousButton = isMobile ? (
			<StyledIconButton id={this.props.id + "_previous"} style={styles.buttons} icon={"navigateleft"} onPress={this.onPrevious} disabled={previousDisabled} />
		) : (
			<StyledButton id={this.props.id + "_previous"} contrast style={styles.buttons} onPress={this.onPrevious} title={previousText} disabled={previousDisabled} />
		);

		var renderNextButton = isMobile ? (
			<StyledIconButton id={this.props.id + "_next"} style={styles.buttons} icon={"navigateright"} onPress={this.onNext} disabled={nextDisabled} />
		) : (
			<StyledButton id={this.props.id + "_next"} contrast style={styles.buttons} onPress={this.onNext} title={nextText} disabled={nextDisabled} />
		);

		return (
			<InputContainer>
				<View style={styles.container}>
					{renderPreviousButton}
					<View style={styles.spacer} />
					{renderNextButton}
				</View>
			</InputContainer>
		);
	}
}

function onPrevious(){
	var newNumber = --this.state.number;
	this.setState({
		number: newNumber
	});
	this.props.onChange(newNumber);
}

function onNext(){
	var newNumber = ++this.state.number;
	this.setState({
		number: newNumber
	});
	this.props.onChange(newNumber);
	this.onChangePage();
}

IncrementalButtons.contextTypes = {
	localize: PropTypes.func
};
